<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="train-drag-{{direction}} pull-left">
    <div class="train-drag-header noselect">
        <span class="train-drag-arrow" *ngIf="direction === 'right'" (click)="toggleCollpase(false,$event,true);visible();">
            <i class="inbound-left" [ngClass]="{'left': collpase === null,'right':collpase !== null}"> </i>
                    <!--<img  class="inbound-left " width="14px" height="14px"  [src]="collpase === null ? imagesPath.arrow.black.left :imagesPath.arrow.black.right">-->
        </span>
        <span class="train-drag-arrow" *ngIf="direction === 'left'" (click)="toggleCollpase(true,$event,true);visible();">
            <i class="inbound-right"  [ngClass]="{'right': collpase === null,'left':collpase !== null}"> </i>
                    <!--<img class="inbound-right" width="14px" height="14px"  [src]="collpase === null ? imagesPath.arrow.black.right  :imagesPath.arrow.black.left">-->
        </span>
        <span class="maximize-panel" (dblclick)="toggleCollpase(direction === 'left'? true : false,$event);visible();">{{header}}
        <span class="train-drag-count" [hidden]="!boundTrainsPartial?.length && collpase !== null">
             {{ startPage }} {{(startPage && endPage) ? ' - ' : ''}} {{ endPage }} {{(startPage && endPage) ? ' of ' : ''}} {{ (startPage && endPage) ? (boundTrains?.length) : '' }}</span>
        </span>
    </div>
    <div class="slide-header" [hidden]="collpase" (click)="resetCollpase()"></div>
    <div id="trainDragContent{{header}}" class="train-drag-content" #viewPortPaging=viewPortpaging lmsViewportPaging [child]="'boundTrainsList'" (getPagingData)="getPagingdata($event)" [style.height.px]='inOutBoundHeight' (scroll)='loadData();hideLocoTrainContextPanel();'
        (window:resize)="visible()">
        <ul *ngFor="let train of boundTrainsPartial; trackBy:trackByTrainIdentifier;let trainIndex = index;" class="boundTrainsList" [attr.headerName]="header" [attr.index]="trainIndex">
            <li class="bound-train-svg" *ngIf="user && user.isUserManagerOrDirector" (click)="onTrainClick(train,$event,trainIndex)" [ngClass]="{'inPending':train?.inPendingList,'selectedDraged':train?.clicked && !train?.inPendingList}" [attr.Identifier]="train?.trainIdentifier"
                [attr.index]="trainIndex" id='train{{trainIndex}}{{header}}{{train?.trainIdentifier}}' (contextmenu)='$event.preventDefault(); showTrainContextMenu(train, trainIndex);'>

                <lms-train-svg [trainData]="train" [screenName]="'Terminal'" [isDefaultTrainIcon]="false"></lms-train-svg>
            </li>
            <li class="bound-train-svg" *ngIf="user && !user.isUserManagerOrDirector" [ngClass]="{'inPending':train?.inPendingList,'selectedDraged':train?.clicked && !train?.inPendingList}" [attr.Identifier]="train?.trainIdentifier" [attr.index]="trainIndex" id='train{{trainIndex}}{{header}}{{train?.trainIdentifier}}'
                (contextmenu)='$event.preventDefault(); showTrainContextMenu(train, trainIndex);'>

                <lms-train-svg [trainData]="train" [screenName]="'Terminal'" [isDefaultTrainIcon]="false"></lms-train-svg>

            </li>
            <div class="boundTrainLocos" *ngIf="user && user.isUserManagerOrDirector" lmsDropZone [parentSelector]="'boundTrainsList'" [trains]="boundTrainsPartial" [allData]="allData" [locos]="train?.locoDetails" [childSelector]="'trainLocos'">

                <li id='train{{train?.trainIdentifier}}loco{{locoDetails.locomotiveIdentifier}}{{trainIndex}}{{header}}'
                  (click)="onLocoClick(locoDetails,$event)"
                  [attr.draggable]="(locoDetails.locomotiveIdentifier.toLowerCase() !=='zzzzzzzzzzzzzz') && !locoDetails?.inPendingList"
                  [attr.Identifier]="locoDetails.locomotiveIdentifier"
                  *ngFor="let locoDetails of train?.locoDetails;  let locoIndex = index; " (mouseenter)="startLocoTooltip(locoDetails)"
                  (mouseleave)="hideLocoTooltip(locoDetails)"
                  [ngClass]="{'inPending':locoDetails?.inPendingList,'selectedDraged':locoDetails?.clicked && !locoDetails?.inPendingList}"
                  (contextmenu)='$event.preventDefault(); showLocomotiveContextMenu(train, locoDetails, trainIndex);'
                  [attr.index]="locoIndex" class="trainLocos">
                  <lms-loco-svg [loco]="locoDetails" [tab]="tab" [trainData]="train" [svgWidthClass]="'carousel-svg'"></lms-loco-svg>

                  <div class="panel-right" id="contextPanelID"
                    *ngIf="locoDetails?.showTooltip && ((locoDetails.locomotiveIdentifier.toLowerCase() !=='zzzzzzzzzzzzzz') && !locoDetails?.inPendingList)">
                    <div class="loco-textPanel">
                      <span class="loco-id" *ngIf="locoDetails">{{formatLocomotiveId(locoDetails.locomotiveIdentifier)}}</span>
                      <span class="loco-class">{{locoDetails && locoDetails.clazz ? locoDetails.clazz : '-'}} </span>
                    </div>
                    <div class="loco-infoPanel">
                      <ul>
                        <li>
                          <span class="loco-label">
                            Dead Date
                          </span>
                          <span class="loco-value">
                            {{locoDetails && locoDetails.deadDate ? formatDateOnly(locoDetails.deadDate) : '-'}}
                          </span>
                        </li>
                        <li>
                          <span class="loco-label">
                            {{getDescription(locoDetails)}}
                          </span>
                          <span class="loco-value">
                          </span>
                        </li>

                      </ul>
                    </div>
                  </div>
                </li>

            </div>
            <div class="boundTrainLocos" *ngIf="user && !user.isUserManagerOrDirector">
                <li id='train{{train?.trainIdentifier}}loco{{locoDetails.locomotiveIdentifier}}{{trainIndex}}{{header}}' [attr.draggable]="false" [attr.Identifier]="locoDetails.locomotiveIdentifier" *ngFor="let locoDetails of train?.locoDetails;  let locoIndex = index; "
                    [ngClass]="{'inPending':locoDetails?.inPendingList,'selectedDraged':locoDetails?.clicked && !locoDetails?.inPendingList }"
                    (mouseenter)="startLocoTooltip(locoDetails)" (mouseleave)="hideLocoTooltip(locoDetails)"
                    (contextmenu)='$event.preventDefault(); showLocomotiveContextMenu(train, locoDetails,trainIndex);' [attr.index]="locoIndex"
                    class="trainLocos">
                    <lms-loco-svg [loco]="locoDetails" [tab]="tab" [trainData]="train" [svgWidthClass]="'carousel-svg'"></lms-loco-svg>

                    <div class="panel-right" id="contextPanelID"
                    *ngIf="locoDetails?.showTooltip && ((locoDetails.locomotiveIdentifier.toLowerCase() !=='zzzzzzzzzzzzzz') && !locoDetails?.inPendingList)">
                    <div class="loco-textPanel">
                      <span class="loco-id" *ngIf="locoDetails">{{formatLocomotiveId(locoDetails.locomotiveIdentifier)}}</span>
                      <span class="loco-class">{{locoDetails && locoDetails.clazz ? locoDetails.clazz : '-'}} </span>
                    </div>
                    <div class="loco-infoPanel">
                      <ul>
                        <li>
                          <span class="loco-label">
                            Dead Date
                          </span>
                          <span class="loco-value">
                            {{locoDetails && locoDetails.deadDate ? formatDateOnly(locoDetails.deadDate) : '-'}}
                          </span>
                        </li>
                        <li>
                          <span class="loco-label">
                            {{getDescription(locoDetails)}}
                          </span>
                          <span class="loco-value">
                          </span>
                        </li>

                      </ul>
                    </div>
                  </div>
                </li>

            </div>
            <div class="clear"></div>
        </ul>


    </div>
</div>
